import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "../hooks/apiRequest";
import { settingsKeys, reportKeys } from "../utils/queryKeys";
import type { SlaTargets } from "./reports";

export function useSlaTargets() {
  return useQuery({
    queryKey: settingsKeys.sla(),
    queryFn: async () => (await apiRequest<SlaTargets>("settings/sla")).data,
  });
}

export function useUpdateSlaTargets() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: Partial<SlaTargets>) =>
      (await apiRequest<SlaTargets>("settings/sla", { method: "PUT", body: JSON.stringify(data) })).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.all });
      queryClient.invalidateQueries({ queryKey: reportKeys.all });
    },
  });
}
